<template>
  <div class="exhibition-reg-container">

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="파트너 기획전 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-5">
                <admin-form-item label="파트너 기획전 제목*">
                  <input class="input"
                        :value="showcaseItem.title"
                        @input="e => showcaseItem.title = e.target.value"
                        placeholder="파트너 기획전 제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="파트너 기획전 대표 이미지">
                  <input-img :url.sync="showcaseItem.img"></input-img>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="에디터영역 사용 여부">
                  <div>
                    <lp-radio :val.sync="showcaseItem.editor_type"
                              value_name="value"
                              label_name="label"
                              :data="editorArr"></lp-radio>
                    <div v-show="showcaseItem.editor_type===true"
                        style="display:flex; padding-top: 8px;" >
                      <lp-editor :text.sync="showcaseItem.info"></lp-editor>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="카테고리 기능 사용 여부">
                  <div>
                    <lp-radio :val.sync="showcaseItem.category_type"
                              value_name="value"
                              label_name="label"
                              :data="categoryArr"></lp-radio>
                    <div v-show="showcaseItem.category_type===true"
                        style="display:flex; padding-top: 8px;" >
                      <button class="button is-primary" style="margin:12px 0"
                          @click="openCategoryModal">카테고리 추가</button>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="기획전 노출 여부">
                  <div>
                    <lp-radio :val.sync="showcaseItem.display_type"
                              value_name="value"
                              label_name="label"
                              :data="displayArr"></lp-radio>
                    <div v-show="showcaseItem.display_type===1"
                        style="display:flex; padding-top: 8px;" >
                      <admin-date-picker
                        :data="showcaseItem.start_date"
                        @setDate="selDateMin"></admin-date-picker>
                      <div class="lp-dating">&#126;</div>
                      <admin-date-picker
                            :data="showcaseItem.end_date"
                            @setDate="selDateMax"></admin-date-picker>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="파트너 기획전 종류">
                  <lp-radio :val.sync="showcaseItem.type"
                        :data="exhibitionArr" ></lp-radio>
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="파트너 기획전 설명">
                  <textarea placeholder="파트너 기획전 설명을 작성하세요."
                            class="textarea"
                            v-model="showcaseItem.desc"></textarea>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <template v-if="showcaseItem.category_type===true && showcaseItem.categories.length>0">
        <div v-for="(item,idx) in showcaseItem.categories" :key="'category-box'+idx"
          class="column is-full">
          <div class="box">
            <admin-box-item :title="`${item.name} 구성 파트너정보`">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="파트너 검색">
                    <button class="button is-primary"
                            @click="openSelectPartner(idx+1)">파트너검색</button>
                  </admin-form-item>

                  <div style="overflow-x: auto">
                    <table class="table">
                      <thead>
                        <tr class="tr-whole-border">
                          <th></th>
                          <th>순서</th>
                          <th>id</th>
                          <th>등록일</th>
                          <th>파트너명</th>
                          <th>이미지</th>
                          <th>파트너 삭제</th>
                        </tr>
                      </thead>
                      <draggable element="tbody" v-model="item.partner_list" handle=".item">
                        <tr v-for="(pi,idx) in item.partner_list" :key="'partner-item'+idx" class="lp-row many-field-tr">
                          <td class="item">
                            <div class="unselect" style="padding: 4px 4px 0 0">
                              <i style="color:#ccc" class="material-icons">drag_indicator</i>
                            </div>
                          </td>
                          <td>{{ pi.index }}</td>
                          <td>{{ pi.id }}</td>
                          <td>{{ pi.created_time }}</td>
                          <td>{{ pi.name }}</td>
                          <td>
                            <div style="text-align: center;display: inline-block"
                                :style="thumbImgField(pi.first_img)" v-if="pi.img"></div>
                          </td>
                          <td><button class="button is-danger" @click="deletePartnerItem(idx, item)">삭제</button></td>
                        </tr>
                      </draggable>
                    </table>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="column is-full">
          <div class="box">
            <admin-box-item title="기획전 구성 파트너정보">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="파트너 검색">
                    <button class="button is-primary"
                            @click="openSelectPartner(undefined)">파트너검색</button>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
          <div class="box">
            <admin-box-item title="파트너 정보">
              <div style="overflow-x: auto">
                <table class="table">
                  <thead>
                    <tr class="tr-whole-border">
                      <th></th>
                      <th>순서</th>
                      <th>id</th>
                      <th>등록일</th>
                      <th>파트너명</th>
                      <th>이미지</th>
                      <th>파트너 삭제</th>
                    </tr>
                  </thead>
                  <draggable element="tbody" v-model="showcaseItem.partner_list" handle=".item">
                    <tr v-for="(pi,idx) in showcaseItem.partner_list" :key="'partner-item'+idx" class="lp-row many-field-tr">
                      <td class="item">
                        <div class="unselect" style="padding: 4px 4px 0 0">
                          <i style="color:#ccc" class="material-icons">drag_indicator</i>
                        </div>
                      </td>
                      <td>{{ pi.index }}</td>
                      <td>{{ pi.id }}</td>
                      <td>{{ pi.created_time }}</td>
                      <td>{{ pi.name }}</td>
                      <td>
                        <div style="text-align: center;display: inline-block"
                            :style="thumbImgField(pi.first_img)" v-if="pi.img"></div>
                      </td>
                      <td><button class="button is-danger" @click="deletePartnerItem(idx)">삭제</button></td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </admin-box-item>
          </div>
        </div>
      </template>
    </div>

    <modal name="partnerListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <partner-list @tableItems="partnerItems" page="exhibition" :selectedItems="selectedCategory ? showcaseItem.categories[selectedCategory-1].partners : showcaseItem.partners" style="zoom: 0.85"></partner-list>
    </modal>

    <sweet-modal ref="categoryModal">
      <modal-add-exhibition-category @update:category="saveCategory"
        :list="categoryList" type="partner"></modal-add-exhibition-category>
    </sweet-modal>
  </div>
</template>

<script>
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import InputImg from "../../module/common/InputImg";
import LpAddress from "../../module/common/LpAddress";
import LpAdmDropInput from "../../module/common/LpAdmDropInput";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";
import { SweetModal } from 'sweet-modal-vue';
import CreateMixin from '@/mixins/CreateMixin';
import PartnerList from "../partner/PartnerList";
import draggable from 'vuedraggable'
import ModalAddExhibitionCategory from '@/components/module/modal/ModalAddExhibitionCategory'

export default {
  layout: "ExhibitionPartnerReg",
  components: {
    PartnerList,
    LpInputText,
    LpRadio,
    InputImg,
    LpAddress,
    LpAdmDropInput,
    SweetModal,
    LpCheckBool,
    LpSortDropDown,
    draggable,
    ModalAddExhibitionCategory
  },
  mixins: [
    CreateMixin
  ],
  created() {
    /*this.nowTime=moment().format('YY-MM-DD');

    let start_year = parseInt(moment().format('YYYY'));
    let start_month = parseInt(moment().format('M'));
    let start_date = parseInt(moment().format('D'));

    let end_year = parseInt(moment().add(5, 'days').format('YYYY'));
    let end_month = parseInt(moment().add(5, 'days').format('M'));
    let end_date = parseInt(moment().add(5, 'days').format('D'));

    // this.showcaseItem.start_date = moment().format('YY-MM-DD');
    // this.showcaseItem.end_date = moment().add(5 ,'days').format('YY-MM-DD');
    this.showcaseItem.start_date = new Date (start_year, start_month-1, start_date);
    this.showcaseItem.end_date = new Date (end_year, end_month-1, end_date);
*/
    this.getData();
  },
  data() {
    return {
      nowTime: '',
      // 파트너 기획전 정보
      showcaseItem: {
        id: 0,
        // 기획전 등록일
        reg_date: '',
        // 노출여부 (현재 노출할것인지)
        display_type: 0,
        editor_type: false,
        category_type: false,
        // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
        // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
        start_date:'',
        end_date:'',
        partners:[],
        partner_list: [],
        categories: [],
        type: '파트너 기획전',
        img: '',
        title: '',
        info: '',
        description: '',
        count: 20
      },
      // showcaseItem: {
      //   id: 82,
      //   // 기획전 등록일
      //   reg_date: '17-12-30 10:24:20',
      //   // 노출여부 (현재 노출할것인지)
      //   display: true,
      //   // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
      //   // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
      //   displayAll: {
      //     state: true,   // true: 상시노출, false: 기간노출
      //     start: '18-01-02 12:00:00',
      //     end: '99-12-31 23:59:59'
      //   },
      //   type: '상품기획전',
      //   img: 'http://pds.joins.com/news/component/newsis/201308/06/NISI20130806_0008507689_web.jpg',
      //   title: '여름맞이 창고 대개방',
      //   description: '여름맞이 창고 대개방 최대 70%까지 할인 행사',
      //   count: 20
      // },
      // 노출여부
      displayArr: [
        { label: '노출', value: 0 },
        { label: '기간노출', value: 1 },
        { label: '노출안함', value: 2 }
      ],
      editorArr: [
        { label: '사용', value: true },
        { label: '미사용', value: false },
      ],
      // 카테고리 기능 사용 여부
      categoryArr: [
        { label: '사용', value: true },
        { label: '미사용', value: false },
      ],
      // 기간별 노출여부
      displayTermArr: [
        { label: '전체', value: '전체' },
        { label: '상시노출', value: '상시노출' },
        { label: '기간노출', value: '기간노출' }
      ],
      exhibitionArr: [
        { label: '상품기획전', value: '상품기획전'},
        { label: '테스트기획전1', value: '테스트기획전1'},
        { label: '테스트기획전2', value: '테스트기획전2'}
      ],
      // 상품정보
      partnerTable: [
        /*{
          hit: 0,
          name: "스몰장례 빈소형 상품",
          img:
            "https://dispatch.cdnser.be/wp-content/uploads/2017/10/20171018195354_1.jpg",
          // img: '3bd008d01e934c1485cd539199298854.png',
          region: "광주 동구",
          buy: 0,
          favorite: 0,
          display: "O",
          price: "10000 / kg",
          tag: ["스몰장례"],
          qna: 0,
          review: 0,
          date: "18-02-07 10:01",
          partner: "파트너",
          cat: "장례 > 장례업체",
          order: 0,
          id: 17      // 상품 id
        }*/
      ],
      categoryList: [],
      selectedCategory: undefined
    }
  },
  watch: {
    /*modalResponse(n){
      if(n==='close'){
        this.showcaseItem.partners = n.partnerIdArr;
        this.partnerTable = n.partnerTable;
      }
    }*/
    'showcaseItem.partner_list'() {
      this.rearrangeIndex();
    }
  },
  methods: {
    visibleField(key) {
      let is_key = false;
      if(this.showcaseItem.partner_list.length > 0) {
        for(let i=0; i<this.showcaseItem.partner_list.length; i++) {
          if(this.showcaseItem.partner_list[i][key]) is_key = true;
          break;
        }
      }
      return is_key;
    },
    // 상품 정보 리스트
    partnerItems(res){
      if(this.showcaseItem.category_type===true && this.showcaseItem.categories.length>0) {
        this.showcaseItem.categories[this.selectedCategory-1].partner_list = res.tableItems;
        this.showcaseItem.categories[this.selectedCategory-1].partners = res.id_list;
      }
      else {
        // this.showcaseItem.partners = [];
        // this.showcaseItem.partner_list = [];
        //
        // this.showcaseItem.partners = res.id_list;
        // this.showcaseItem.partner_list = res.tableItems;
        for(let i=0; i<res.id_list.length; i++){
          if(this.showcaseItem.partners.includes(res.id_list[i])===false){
            this.showcaseItem.partners.push(res.id_list[i]);
            this.showcaseItem.partner_list.push(res.tableItems[i]);
            this.showcaseItem.partners.push(res.id_list[i]);
          }
        }
      }
      this.$modal.hide('partnerListModal');
      console.log('partnerItems', this.showcaseItem)
    },
    // 기획전 등록 파트너 검색
    openSelectPartner(idx){
      this.selectedCategory = idx;
      this.$modal.show('partnerListModal');
    },
    openCategoryModal() {
      // this.$modal.show('categoryModal');
      this.$refs.categoryModal.open();
    },
    deletePartnerItem(idx, item){
      if(item) {
        removeIndex(item.partner_list, idx);
        removeIndex(item.partners, idx);
      }
      else {
        removeIndex(this.showcaseItem.partner_list, idx);
        removeIndex(this.showcaseItem.partners, idx);
      }
    },
    selDateMin(date) {
      this.showcaseItem.start_date = date;
      // this.getData();
    },
    selDateMax(date) {
      this.showcaseItem.end_date = date;
      // this.getData();
    },
    // 삭제
    clickDelete(idx) {
      this.commentsArr.splice(idx, 1);
    },
    saveData() {
      let err = '';
      if(!this.showcaseItem.title) {
        err = '기획전 제목을 입력해주세요.';
      }

      if(err) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.showcaseItem);
      if(!value.start_date){
        value.start_date = '1111-01-01';
      }
      if(!value.end_date){
        value.end_date = '9999-01-01';
      }
      if(this.$route.query.id){
        this.$axios.patch(this.getUrl('exhibition_partner/')+this.$route.query.id, value).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('exhibition_partner'));
          }
        })
      }
      else{
        this.$axios.post(this.getUrl('exhibition_partner'), value).then(res=>{
          if(res.status===200){
            this.saveServiceGuide('partner_exhibition');
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('exhibition_partner'));
          }
        })
      }
    },
    saveCategory(val) {
      console.log('cate',val)
      this.showcaseItem.categories = val;
      this.$refs.categoryModal.close();
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    getData(){
      if(this.$route.query.id){
        this.$axios.get(this.getUrl('exhibition_partner/'+this.$route.query.id)).then(res=>{
          if(res.status===200){
            if(res.data.categories.length>0) {
              this.categoryList = res.data.categories;
            }
            this.showcaseItem = res.data;
          }
        })
      }
    },
    rearrangeIndex() {
      let partners_id = [];
      for(let i=0; i<this.showcaseItem.partner_list.length; i++) {
        this.showcaseItem.partner_list[i]['index'] = i + 1;
        partners_id.push(this.showcaseItem.partner_list[i].id);
      }
      this.showcaseItem.partners = partners_id;
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_variable';
//@import '~assets/css/lp_main';

.tr-whole-border th
  padding 12px 6px

.many-field-tr td
  padding 6px

.user-reg-basic-group-1 {
  width: 50%;
}

.user-reg-basic-group-2 {
  width: 50%;
  margin-top: 137px;
}

.user-reg-content-service {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.user-reg-service-group {
  width: 50%;
  padding-left: 20px;
  margin-bottom: 12px;
}

.user-reg-history-memo {
  width: 380px;
  height: 240px;
  margin: 0 10px;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  overflow-y: auto;
}

.history-memo-item {
  width: 100%;
  margin-bottom: 12px;
}

.user-reg-history-btn {
  background-color: $primary;
  color: #fff;
  display: inline-block;
  padding: 8px 12px;
  margin-left: 8px;
  border-radius: 3px;
  cursor: pointer;
}

.prod-search-btn {
  font-size: 0.8rem;
  background: #e6e6e6;
  padding: 6px 12px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}

.prod-tag
  background-color $point
  display inline-block
  padding 4px 10px
  color #fff
  border-radius 3px
  margin 2px

.prod-detail-content
  padding 20px
  font-size .95rem
  color #222
  border-radius 3px
  border none
  background-color #f2f7f8
  display block
  width 100%
  max-width 900px
  height 120px

.comment-sub-title
  background #ddd
  color #333
  padding 8px 16px
  font-size .95rem
  border-radius 3px
  display flex
  justify-content space-between
</style>
<style lang="stylus">
  .exhibition-reg-container
    .sweet-modal.is-alert
      width 500px
      max-height 90vh
      .sweet-content
        padding 24px 32px
</style>
